document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("ni-offer-popup");

  if (!popup) return;

  const overlay = popup.querySelector(".ni-popup__overlay");
  const closeBtn = popup.querySelector(".ni-popup__close");

  const delay = Number(popup.dataset.delay || 15000);
  const repeat = Number(popup.dataset.repeat || 15000);

  let popupTimer = null;

  function showPopup() {
    popup.classList.add("is-visible");
    document.body.style.overflow = "hidden";
  }

  function hidePopup() {
    popup.classList.remove("is-visible");
    document.body.style.overflow = "";

    clearTimeout(popupTimer);
    popupTimer = setTimeout(showPopup, repeat);
  }

  // Show popup after initial delay
  popupTimer = setTimeout(showPopup, delay);

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener("click", hidePopup);
  }

  // Click outside popup
  if (overlay) {
    overlay.addEventListener("click", hidePopup);
  }

  // ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.classList.contains("is-visible")) {
      hidePopup();
    }
  });

  // Close popup before navigating
  popup.querySelectorAll(".ni-offer-card").forEach(function (card) {
    card.addEventListener("click", function () {
      popup.classList.remove("is-visible");
      document.body.style.overflow = "";
    });
  });
});